<template lang="html">
  <nav class="c-nav">
    <div class="c-nav__left">
      <div class="c-nav__logo">
        <h1>Théo Kleman</h1>
        <span>another developer</span>
      </div>
      <div class="c-nav__menu" :class="displayClose">
        <div class="c-nav__item s--about">
          <span @click.prevent="toggleAboutDisplay">about me</span>
        </div>
        <div class="c-nav__item">
          <a target="_blank" href="https://twitter.com/Theo_KlMan">twitter</a>
        </div>
        <div class="c-nav__item">
          <a target="_blank" href="https://fr.linkedin.com/in/theokleman">linkedin</a>
        </div>
        <div class="c-nav__item">
          <a target="_blank" href="https://github.com/TheoKleman/">github</a>
        </div>
        <div class="c-nav__item">
          <a target="_blank" href="http://codepen.io/theElkman/">codepen</a>
        </div>
        <div class="c-nav__item s--close">
          <span @click.prevent="toggleAboutDisplay">close</span>
        </div>
      </div>
    </div>
    <div class="c-nav__right">
      <div class="c-nav__index" :class="displayClose">
        <span v-for="project in projects" :class="{ 's--active' : project.key === currentIndex }"></span>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: {
    display: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'direction',
      'aboutDisplay',
      'currentIndex',
      'projects'
    ]),
    displayClose () {
      return {
        's--close--displayed': this.aboutDisplay === true
      }
    },
    projectIndex () {
      return this.currentIndex + 1 + '/' + this.projects.length
    }
  },
  methods: {
    toggleAboutDisplay () {
      if (this.aboutDisplay === true) {
        this.$store.dispatch('setAboutDisplay', false)
      } else {
        this.$store.dispatch('setAboutDisplay', true)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../vars.scss";

.c-nav {
  display: flex;
  justify-content: space-between;
  position: absolute;
  z-index: 60;
  padding: 5% 0;
  left: 13%;
  right: 13%;
  width: calc(100% - 26%);
  pointer-events: all;
  transition: opacity cubic-bezier(.23,.79,.51,.99) .55s;
  transition-delay: .35s;

  > div {
    display: flex;
  }

  &__logo {
    margin-right: 30px;

    h1 {
      margin: 0;
      color: $white;
      font-family: $proxima;
      font-size: 26px;
      line-height: 20px;
    }

    span {
      margin: 0;
      color: $orange;
      font-family: $proxima;
      font-weight: 400;
      font-size: 14px;
    }
  }

  &__menu {
    position: relative;
    display: flex;

    &.s--close--displayed {
      .c-nav__item {
        opacity: 0;
        pointer-events: none;
        transition: all ease .25s;

        &.s--about, &.s--close {
          opacity: 1;
          pointer-events: all;
        }

        &.s--close {
          transition-delay: .5s;
        }
      }

      &:after {
        transform: scaleX(1);
        transition: all ease .25s;
        transition-delay: .25s;
      }
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 11px;
      left: 100px;
      width: 240px;
      height: 1px;
      background: $white-op;
      transform: scaleX(0);
      transform-origin: left;
      transition: all ease .25s;
    }

    @media screen and (max-width: $mobile) {
      > .c-nav__item.s--close {
        display: none;
      }

      &.s--close--displayed {
        &:after {
          transform: scaleX(0);
        }
      }
    }
  }

  &__item {
    margin-left: 20px;
    transition: all ease .25s;
    transition-delay: .5s;

    span, a {
      text-decoration: none;
      margin: 0;
      color: $white-op;
      font-family: $proxima;
      font-weight: 400;
      font-size: 14px;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: $white;
      }
    }

    &.s--close {
      position: relative;
      opacity: 0;
      pointer-events: none;
      transition-delay: 0s;
    }

    @media screen and (max-width: $tablet) {
      opacity: 0;
      pointer-events: none;

      &.s--about {
        opacity: 1;
        pointer-events: all;
      }
    }

    @media screen and (max-width: $mobile) {
      display: none;

      &.s--about {
        display: block;
      }
    }
  }

  &__index {
    display: flex;
    justify-content: flex-end;
    padding-top: 5px;
    transition: all ease .25s;
    transition-delay: .5s;

    > span {
      display: flex;
      width: 2px;
      height: 10px;
      margin-left: 5px;
      background: $white-op;
      font-family: $proxima;
      font-weight: 400;
      font-size: 14px;
      transition: height ease .25s;


      &.s--active {
        height: 14px;
        transition: height ease .25s;
      }
    }

    &.s--close--displayed {
      opacity: 0;
      transition: all ease .25s;
    }

    @media screen and (max-width: $mobile) {
      display: none;
    }
  }

  @media screen and (max-width: $tablet) {
    width: calc(100% - 10%);
    left: 5%;
    right: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?0b9c0940